export const translationEngDefault = {
  SkhemataBlogFeatured: {
    readMore: 'READ MORE',
  }
};
